
import {map} from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { LinkGroup } from './link-group';
import { Apollo } from 'apollo-angular';

const createLinkGroupMutation = require('./gql/create-link-group.mutation.gql');
const updateLinkGroupMutation = require('./gql/update-link-group.mutation.gql');
const deleteLinkGroupAndLinksMutation = require('./gql/delete-link-group-and-links.mutation.gql');
const duplicateLinkGroupAndLinksMutation = require('./gql/duplicate-link-group-and-links.mutation.gql');

/**
 * Service to manage link groups
 */
@Injectable()
export class LinkGroupService {

  constructor(private apollo: Apollo) { }

  create(dossier_id: string, group: LinkGroup): Observable<LinkGroup> {
    return this.apollo
      .mutate({
        mutation: createLinkGroupMutation,
        variables: {
          dossier_id,
          input: group.toCreateLinkGroupInput()
        }
      }).pipe(
      map(result => new LinkGroup(result.data['createLinkGroup'])));
  }

  update(dossier_id: string, id: string, group: LinkGroup): Observable<LinkGroup> {
    return this.apollo
      .mutate({
        mutation: updateLinkGroupMutation,
        variables: {
          dossier_id,
          id,
          input: group.toUpdateLinkGroupInput()
        }
      }).pipe(
      map(result => new LinkGroup(result.data['updateLinkGroup'])));
  }

  deleteLinkGroupAndLinks(dossier_id: string, id: string): Observable<string> {
    return this.apollo
      .mutate({
        mutation: deleteLinkGroupAndLinksMutation,
        variables: {
          dossier_id,
          id
        }
      }).pipe(
      map(result => result.data['deleteLinkGroup']));
  }

  duplicateLinkGroupAndLinks(dossier_id: string, id: string): Observable<LinkGroup> {
    return this.apollo
      .mutate({
        mutation: duplicateLinkGroupAndLinksMutation,
        variables: {
          dossier_id,
          id
        }
      }).pipe(
      map(result => new LinkGroup(result.data['duplicateLinkGroupAndLinks'])));
  }
}